/* unplugin-vue-components disabled */import { render } from "./ciamLogin.vue?vue&type=template&id=185558c8"
import script from "./ciamLogin.vue?vue&type=script&lang=js"
export * from "./ciamLogin.vue?vue&type=script&lang=js"

import "./ciamLogin.vue?vue&type=style&index=0&id=185558c8&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__